import { AfterViewInit, Directive, ElementRef, Input, OnDestroy } from '@angular/core';
import { MatFormField } from '@angular/material/form-field';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AppState } from 'src/app/app.reducer';
import { ScheduleOption } from 'src/app/pages/schedule-register/models/schedule-option-interface';
import { NgrxEagerSelectService } from '../../select/eager-select/ngrx-eager-select-status.service';
import { LcsSingleSelectDirective } from '../../single-select/single-select.directive';
import { scheduleOptionActions } from '../state/schedule-option.actions';
import { scheduleOptionSelectors } from '../state/schedule-option.reducer';

@Directive({
    selector: '[ndtScheduleSelect]',
    standalone: false
})
export class ScheduleSelectInputDirective implements OnDestroy, AfterViewInit {
   @Input() accountId: number | null;

   @Input() additionalFields: string[] | null;

   @Input() urlOverride?: string;

   private destroyed$ = new Subject<void>();

   constructor(
      private elementRef: ElementRef,
      private formField: MatFormField,
      private trigger: LcsSingleSelectDirective<ScheduleOption>,
      private statusService: NgrxEagerSelectService<AppState, ScheduleOption>
   ) {}

   ngAfterViewInit(): void {
      let staticFilterOverride: string[] | undefined;

      if (this.accountId) {
         staticFilterOverride = [`AccountId = ${this.accountId}`];
      }

      this.statusService
         .initialize(
            this.formField,
            this.trigger,
            this.elementRef.nativeElement,
            scheduleOptionActions,
            scheduleOptionSelectors,
            () => {
               return this.additionalFields;
            },
            () => {
               return this.urlOverride;
            },
            () => {
               return this.statusService.buildPrimaryKeyFilterExpression('scheduleId', this.trigger);
            },
            staticFilterOverride
         )
         .pipe(takeUntil(this.destroyed$))
         .subscribe();
   }

   ngOnDestroy(): void {
      this.destroyed$.next();
   }
}
